export enum ViewerDisplayDirection {
    Top = 0,
    Bottom = 1,
    Left = 2,
    Right = 3,
    Front = 4,
    Back = 5,
    SouthWest = 6,
    SouthEast = 7,
    NorthWest = 8,
    NorthEast = 9,
}